module.exports = __webpack_public_path__ + "static/media/5.282a29aa.jpg";